import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL, LOCATION_ID } from "..";
import { Spinner } from "react-bootstrap";
import PurchaseOrderListLayer from "../components/PurchaseOrderListLayer";
import ExpensesListLayer from "../components/ExpensesListLayer";

const ExpenseListPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const locationId =   localStorage.getItem('locationID')

  const fetchExpenses = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/expenses?locationId=${locationId}`);
      const result = await response.json();
      setData(result.data);
    } catch (err) {
      console.error("Error fetching purchase orders:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Purchase Orders - List" />
      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}
      {/* {!loading && data?.length === 0 && (
        <div className="text-center mt-4">
          <p>No Purchase Order data found....</p>
        </div>
      )} */}
      {!loading  && <ExpensesListLayer expensesData={data} />}
    </MasterLayout>
  );
};

export default ExpenseListPage;
